import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Portal } from '@angular/cdk/portal';

@Injectable()
export class TooltipService {
  get portal$() {
    return this.portalSubject.asObservable();
  }

  private portalSubject: BehaviorSubject<Portal<any>>;

  setPortal(portal: Portal<any>) {
    this.portalSubject.next(portal);
  }

  constructor() {
    this.portalSubject = new BehaviorSubject(undefined);
  }
}
